import { render, staticRenderFns } from "./CommissionSubTable.vue?vue&type=template&id=165396a8&"
import script from "./CommissionSubTable.vue?vue&type=script&lang=ts&"
export * from "./CommissionSubTable.vue?vue&type=script&lang=ts&"
import style0 from "./CommissionSubTable.vue?vue&type=style&index=0&id=165396a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports